import React from 'react'

export default function Calculations() {
  return (
    <div>
        <h1>this is the calculations page</h1>
    </div>
  )
}

